// import { QuestionaireType } from "../molecules/Questionaire";


export enum ProfileTab {
  ProfileInfo = 'Profile Information',
  Membership = 'Membership Credentials',
  Subscriptions = 'My Subscriptions',
}

export const stateCountyCoordinates: Record<string, { lat: number; lng: number }> = {
  AL: { lat: 32.806671, lng: -86.791130 },
  AK: { lat: 61.370716, lng: -152.404419 },
  AZ: { lat: 33.729759, lng: -111.431221 },
  AR: { lat: 34.969704, lng: -92.373123 },
  CA: { lat: 36.116203, lng: -119.681564 },
  CO: { lat: 39.059811, lng: -105.311104 },
  CT: { lat: 41.597782, lng: -72.755371 },
  DE: { lat: 39.318523, lng: -75.507141 },
  FL: { lat: 27.766279, lng: -81.686783 },
  GA: { lat: 33.040619, lng: -83.643074 },
  HI: { lat: 21.094318, lng: -157.498337 },
  ID: { lat: 44.240459, lng: -114.478828 },
  IL: { lat: 40.349457, lng: -88.986137 },
  IN: { lat: 39.849426, lng: -86.258278 },
  IA: { lat: 42.011539, lng: -93.210526 },
  KS: { lat: 38.526600, lng: -96.726486 },
  KY: { lat: 37.668140, lng: -84.670067 },
  LA: { lat: 31.169546, lng: -91.867805 },
  ME: { lat: 44.693947, lng: -69.381927 },
  MD: { lat: 39.063946, lng: -76.802101 },
  MA: { lat: 42.230171, lng: -71.530106 },
  MI: { lat: 43.326618, lng: -84.536095 },
  MN: { lat: 45.694454, lng: -93.900192 },
  MS: { lat: 32.741646, lng: -89.678696 },
  MO: { lat: 38.456085, lng: -92.288368 },
  MT: { lat: 46.921925, lng: -110.454353 },
  NE: { lat: 41.125370, lng: -98.268082 },
  NV: { lat: 38.313515, lng: -117.055374 },
  NH: { lat: 43.452492, lng: -71.563896 },
  NJ: { lat: 40.298904, lng: -74.521011 },
  NM: { lat: 34.840515, lng: -106.248482 },
  NY: { lat: 42.165726, lng: -74.948051 },
  NC: { lat: 35.630066, lng: -79.806419 },
  ND: { lat: 47.528912, lng: -99.784012 },
  OH: { lat: 40.388783, lng: -82.764915 },
  OK: { lat: 35.565342, lng: -96.928917 },
  OR: { lat: 44.572021, lng: -122.070938 },
  PA: { lat: 40.590752, lng: -77.209755 },
  RI: { lat: 41.680893, lng: -71.511780 },
  SC: { lat: 33.856892, lng: -80.945007 },
  SD: { lat: 44.299782, lng: -99.438828 },
  TN: { lat: 35.747845, lng: -86.692345 },
  TX: { lat: 31.054487, lng: -97.563461 },
  UT: { lat: 40.150032, lng: -111.862434 },
  VT: { lat: 44.045876, lng: -72.710686 },
  VA: { lat: 37.769337, lng: -78.169968 },
  WA: { lat: 47.400902, lng: -121.490494 },
  WV: { lat: 38.491226, lng: -80.954456 },
  WI: { lat: 44.268543, lng: -89.616508 },
  WY: { lat: 42.755966, lng: -107.302490 },
  DC: { lat: 38.9072, lng: -77.0369 },
  nationwide: { lat: 37.0902, lng: -95.7129 },
};

export const foodBusinessCategories = [
    {
      "category": "Restaurants",
      "types": [
        "Fine Dining Restaurant",
        "Casual Dining Restaurant",
        "Fast Casual Restaurant",
        "Fast Food Restaurant",
        "Family Restaurant",
        "Bistro",
        "Gastropub",
        "Buffet Restaurant",
        "Pop-up Restaurant",
        "Ghost Kitchen/Virtual Restaurant",
        "Food Truck",
        "Drive-in Restaurant",
        "Drive-through Restaurant",
        "Farm-to-table Restaurant",
        "Theme Restaurant"
      ]
    },
    {
      "category": "Specialty Restaurants",
      "types": [
        "Steakhouse",
        "Seafood Restaurant",
        "Pizzeria",
        "Sushi Bar",
        "Barbecue Restaurant",
        "Vegetarian/Vegan Restaurant",
        "Health Food Restaurant",
        "Raw Food Restaurant",
        "Ethnic Restaurant",
        "Fusion Restaurant",
        "Tapas Restaurant",
        "Wine Bar & Restaurant",
        "Brew Pub",
        "Deli",
        "Sandwich Shop"
      ]
    },
    {
      "category": "Cafes and Beverage Establishments",
      "types": [
        "Coffee Shop",
        "Tea House",
        "Juice Bar",
        "Smoothie Shop",
        "Bubble Tea Shop",
        "Café-Bakery",
        "Internet Café",
        "Dessert Café",
        "Ice Cream Parlor",
        "Frozen Yogurt Shop"
      ]
    },
    {
      "category": "Bakeries and Dessert Shops",
      "types": [
        "Artisan Bakery",
        "Commercial Bakery",
        "Pastry Shop",
        "Cake Shop",
        "Donut Shop",
        "Cookie Shop",
        "Chocolate Shop",
        "Confectionery",
        "Gelato Shop",
        "Candy Store"
      ]
    },
    {
      "category": "Food Retail and Production",
      "types": [
        "Specialty Food Store",
        "Gourmet Food Shop",
        "Food Hall",
        "Food Market",
        "Commercial Kitchen",
        "Commissary Kitchen",
        "Food Manufacturing Facility",
        "Bottling Facility",
        "Food Processing Plant",
        "Food Packaging Facility"
      ]
    },
    {
      "category": "Catering and Events",
      "types": [
        "Full-Service Catering",
        "Corporate Catering",
        "Wedding Catering",
        "Event Planning and Catering",
        "Mobile Catering",
        "Concession Stand",
        "Food Cart",
        "Banquet Hall",
        "Private Dining Service",
        "Personal Chef Service"
      ]
    },
    {
      "category": "Institutional Food Service",
      "types": [
        "School Cafeteria",
        "University Dining Hall",
        "Hospital Food Service",
        "Corporate Cafeteria",
        "Military Mess Hall",
        "Prison Food Service",
        "Nursing Home Food Service",
        "Airport Food Service",
        "Stadium Concessions",
        "Museum Café"
      ]
    },
    {
      "category": "Food Distribution and Wholesale",
      "types": [
        "Food Distributor",
        "Restaurant Supply Store",
        "Wholesale Food Supplier",
        "Specialty Food Distributor",
        "Beverage Distributor",
        "Fresh Produce Distributor",
        "Meat and Seafood Distributor",
        "Dairy Distributor",
        "Frozen Food Distributor",
        "Import/Export Food Business"
      ]
    },
    {
      "category": "Specialty Food Services",
      "types": [
        "Meal Prep Service",
        "Meal Kit Delivery Service",
        "Food Subscription Box Service",
        "Diet Food Delivery Service",
        "Organic Food Service",
        "Allergen-Free Food Service",
        "Baby Food Service",
        "Pet Food Kitchen",
        "Nutritional Consulting Service",
        "Food Safety Consulting"
      ]
    },
    {
      "category": "Culinary Education and Training",
      "types": [
        "Culinary School",
        "Cooking Class Provider",
        "Food Safety Training Center",
        "Wine Tasting School",
        "Barista Training Center",
        "Bartending School",
        "Food Photography Studio",
        "Food Styling Service",
        "Recipe Development Kitchen",
        "Test Kitchen"
      ]
    }
]

export const culinaryCategories = [
  "Restaurant",
  "Cafe",
  "Coffee Shop",
  "Food Truck",
  "Catering Service",
  "Bakery",
  "Pizzeria",
  "Bar",
  "Pub",
  "Nightclub",
  "Fine Dining Restaurant",
  "Casual Dining Restaurant",
  "Fast Food Restaurant",
  "Buffet",
  "Diner",
  "Food Hall",
  "Meal Prep Service",
  "Meal Kit Delivery Service",
  "Juice Bar",
  "Smoothie Bar",
  "Ice Cream Parlor",
  "Food Manufacturer",
  "Butcher Shop",
  "Specialty Food Store",
  "Grocery Store",
  "Farmers' Market Vendor",
  "Online Food Retailer",
  "Personal Chef Service",
  "Cooking Class Instructor",
  "Culinary School",
  "Private Dining Club",
  "Pop-Up Restaurant",
  "Ghost Kitchen",
  "Food Distribution Service",
  "Farm-to-Table Restaurant",
  "Organic Food Service",
  "Ethnic Cuisine Restaurant",
  "Vegetarian/Vegan Restaurant",
  "Seafood Restaurant",
  "Food and Beverage Consultancy",
  "Dietary/Specialty Foods Provider",
  "Microbrewery",
  "Distillery",
  "Winery",
  "Cannabis-Infused Food Service",
  "Event Catering",
  "Hospital Food Service",
  "School Cafeteria Service",
  "Corporate Catering Service"
]




export const USStatesCounties: { [key: string]: string[] } = {
  AL: ["Autauga", "Baldwin", "Barbour", "Bibb", "Blount", "Bullock", "Butler", "Calhoun", "Chambers", "Cherokee", "Chilton", "Choctaw", "Clarke", "Clay", "Cleburne", "Coffee", "Colbert", "Conecuh", "Coosa", "Covington", "Crenshaw", "Cullman", "Dale", "Dallas", "DeKalb", "Elmore", "Escambia", "Etowah", "Fayette", "Franklin", "Geneva", "Greene", "Hale", "Henry", "Houston", "Jackson", "Jefferson", "Lamar", "Lauderdale", "Lawrence", "Lee", "Limestone", "Lowndes", "Macon", "Madison", "Marengo", "Marion", "Marshall", "Mobile", "Monroe", "Montgomery", "Morgan", "Perry", "Pickens", "Pike", "Randolph", "Russell", "St. Clair", "Shelby", "Sumter", "Talladega", "Tallapoosa", "Tuscaloosa", "Walker", "Washington", "Wilcox", "Winston"],
  AK: ["Aleutians East", "Aleutians West", "Anchorage", "Bethel", "Bristol Bay", "Denali", "Dillingham", "Fairbanks North Star", "Haines", "Hoonah-Angoon", "Juneau", "Kenai Peninsula", "Ketchikan Gateway", "Kodiak Island", "Kusilvak", "Lake and Peninsula", "Matanuska-Susitna", "Nome", "North Slope", "Northwest Arctic", "Petersburg", "Prince of Wales-Hyder", "Sitka", "Skagway", "Southeast Fairbanks", "Wrangell", "Yakutat", "Yukon-Koyukuk"],
  AZ: ["Apache", "Cochise", "Coconino", "Gila", "Graham", "Greenlee", "La Paz", "Maricopa", "Mohave", "Navajo", "Pima", "Pinal", "Santa Cruz", "Yavapai", "Yuma"],
  AR: ["Arkansas", "Ashley", "Baxter", "Benton", "Boone", "Bradley", "Calhoun", "Carroll", "Chicot", "Clark", "Clay", "Cleburne", "Cleveland", "Columbia", "Conway", "Craighead", "Crawford", "Crittenden", "Cross", "Dallas", "Desha", "Drew", "Faulkner", "Franklin", "Fulton", "Garland", "Grant", "Greene", "Hempstead", "Hot Spring", "Howard", "Independence", "Izard", "Jackson", "Jefferson", "Johnson", "Lafayette", "Lawrence", "Lee", "Lincoln", "Little River", "Logan", "Lonoke", "Madison", "Marion", "Miller", "Mississippi", "Monroe", "Montgomery", "Nevada", "Newton", "Ouachita", "Perry", "Phillips", "Pike", "Poinsett", "Polk", "Pope", "Prairie", "Pulaski", "Randolph", "St. Francis", "Saline", "Scott", "Searcy", "Sebastian", "Sevier", "Sharp", "Stone", "Union", "Van Buren", "Washington", "White", "Woodruff", "Yell"],
  CA: ["Alameda", "Alpine", "Amador", "Butte", "Calaveras", "Colusa", "Contra Costa", "Del Norte", "El Dorado", "Fresno", "Glenn", "Humboldt", "Imperial", "Inyo", "Kern", "Kings", "Lake", "Lassen", "Los Angeles", "Madera", "Marin", "Mariposa", "Mendocino", "Merced", "Modoc", "Mono", "Monterey", "Napa", "Nevada", "Orange", "Placer", "Plumas", "Riverside", "Sacramento", "San Benito", "San Bernardino", "San Diego", "San Francisco", "San Joaquin", "San Luis Obispo", "San Mateo", "Santa Barbara", "Santa Clara", "Santa Cruz", "Shasta", "Sierra", "Siskiyou", "Solano", "Sonoma", "Stanislaus", "Sutter", "Tehama", "Trinity", "Tulare", "Tuolumne", "Ventura", "Yolo", "Yuba"],
  CO: ["Adams", "Alamosa", "Arapahoe", "Archuleta", "Baca", "Bent", "Boulder", "Broomfield", "Chaffee", "Cheyenne", "Clear Creek", "Conejos", "Costilla", "Crowley", "Custer", "Delta", "Denver", "Dolores", "Douglas", "Eagle", "Elbert", "El Paso", "Fremont", "Garfield", "Gilpin", "Grand", "Gunnison", "Hinsdale", "Huerfano", "Jackson", "Jefferson", "Kiowa", "Kit Carson", "La Plata", "Lake", "Larimer", "Las Animas", "Lincoln", "Logan", "Mesa", "Mineral", "Moffat", "Montezuma", "Montrose", "Morgan", "Otero", "Ouray", "Park", "Phillips", "Pitkin", "Prowers", "Pueblo", "Rio Blanco", "Rio Grande", "Routt", "Saguache", "San Juan", "San Miguel", "Sedgwick", "Summit", "Teller", "Washington", "Weld", "Yuma"],
  CT: ["Fairfield", "Hartford", "Litchfield", "Middlesex", "New Haven", "New London", "Tolland", "Windham"],
  DE: ["Kent", "New Castle", "Sussex"],
  FL: ["Alachua", "Baker", "Bay", "Bradford", "Brevard", "Broward", "Calhoun", "Charlotte", "Citrus", "Clay", "Collier", "Columbia", "DeSoto", "Dixie", "Duval", "Escambia", "Flagler", "Franklin", "Gadsden", "Gilchrist", "Glades", "Gulf", "Hamilton", "Hardee", "Hendry", "Hernando", "Highlands", "Hillsborough", "Holmes", "Indian River", "Jackson", "Jefferson", "Lafayette", "Lake", "Lee", "Leon", "Levy", "Liberty", "Madison", "Manatee", "Marion", "Martin", "Miami-Dade", "Monroe", "Nassau", "Okaloosa", "Okeechobee", "Orange", "Osceola", "Palm Beach", "Pasco", "Pinellas", "Polk", "Putnam", "St. Johns", "St. Lucie", "Santa Rosa", "Sarasota", "Seminole", "Sumter", "Suwannee", "Taylor", "Union", "Volusia", "Wakulla", "Walton", "Washington"],
  GA: ["Appling", "Atkinson", "Bacon", "Baker", "Baldwin", "Banks", "Barrow", "Bartow", "Ben Hill", "Berrien", "Bibb", "Bleckley", "Brantley", "Brooks", "Bryan", "Bulloch", "Burke", "Butts", "Calhoun", "Camden", "Candler", "Carroll", "Catoosa", "Charlton", "Chatham", "Chattahoochee", "Chattooga", "Cherokee", "Clarke", "Clay", "Clayton", "Clinch", "Cobb", "Coffee", "Colquitt", "Columbia", "Cook", "Coweta", "Crawford", "Crisp", "Dade", "Dawson", "Decatur", "DeKalb", "Dodge", "Dooly", "Dougherty", "Douglas", "Early", "Echols", "Effingham", "Elbert", "Emanuel", "Evans", "Fannin", "Fayette", "Floyd", "Forsyth", "Franklin", "Fulton", "Gilmer", "Glascock", "Glynn", "Gordon", "Grady", "Greene", "Gwinnett", "Habersham", "Hall", "Hancock", "Haralson", "Harris", "Hart", "Heard", "Henry", "Houston", "Irwin", "Jackson", "Jasper", "Jeff Davis", "Jefferson", "Jenkins", "Johnson", "Jones", "Lamar", "Lanier", "Laurens", "Lee", "Liberty", "Lincoln", "Long", "Lowndes", "Lumpkin", "McDuffie", "McIntosh", "Macon", "Madison", "Marion", "Meriwether", "Miller", "Mitchell", "Monroe", "Montgomery", "Morgan", "Murray", "Muscogee", "Newton", "Oconee", "Oglethorpe", "Paulding", "Peach", "Pickens", "Pierce", "Pike", "Polk", "Pulaski", "Putnam", "Quitman", "Rabun", "Randolph", "Richmond", "Rockdale", "Schley", "Screven", "Seminole", "Spalding", "Stephens", "Stewart", "Sumter", "Talbot", "Taliaferro", "Tattnall", "Taylor", "Telfair", "Terrell", "Thomas", "Tift", "Toombs", "Towns", "Treutlen", "Troup", "Turner", "Twiggs", "Union", "Upson", "Walker", "Walton", "Ware", "Warren", "Washington", "Wayne", "Webster", "Wheeler", "White", "Whitfield", "Wilcox", "Wilkes", "Wilkinson", "Worth"],
  HI: ["Hawaii", "Honolulu", "Kalawao", "Kauai", "Maui"],
  ID: ["Ada", "Adams", "Bannock", "Bear Lake", "Benewah", "Bingham", "Blaine", "Boise", "Bonner", "Bonneville", "Boundary", "Butte", "Camas", "Canyon", "Caribou", "Cassia", "Clark", "Clearwater", "Custer", "Elmore", "Franklin", "Fremont", "Gem", "Gooding", "Idaho", "Jefferson", "Jerome", "Kootenai", "Latah", "Lemhi", "Lewis", "Lincoln", "Madison", "Minidoka", "Nez Perce", "Oneida", "Owyhee", "Payette", "Power", "Shoshone", "Teton", "Twin Falls", "Valley", "Washington"],
  IL: ["Adams", "Alexander", "Bond", "Boone", "Brown", "Bureau", "Calhoun", "Carroll", "Cass", "Champaign", "Christian", "Clark", "Clay", "Clinton", "Coles", "Cook", "Crawford", "Cumberland", "DeKalb", "De Witt", "Douglas", "DuPage", "Edgar", "Edwards", "Effingham", "Fayette", "Ford", "Franklin", "Fulton", "Gallatin", "Greene", "Grundy", "Hamilton", "Hancock", "Hardin", "Henderson", "Henry", "Iroquois", "Jackson", "Jasper", "Jefferson", "Jersey", "Jo Daviess", "Johnson", "Kane", "Kankakee", "Kendall", "Knox", "Lake", "LaSalle", "Lawrence", "Lee", "Livingston", "Logan", "Macon", "Macoupin", "Madison", "Marion", "Marshall", "Mason", "Massac", "McDonough", "McHenry", "McLean", "Menard", "Mercer", "Monroe", "Montgomery", "Morgan", "Moultrie", "Ogle", "Peoria", "Perry", "Piatt", "Pike", "Pope", "Pulaski", "Putnam", "Randolph", "Richland", "Rock Island", "St. Clair", "Saline", "Sangamon", "Schuyler", "Scott", "Shelby", "Stark", "Stephenson", "Tazewell", "Union", "Vermilion", "Wabash", "Warren", "Washington", "Wayne", "White", "Whiteside", "Will", "Williamson", "Winnebago", "Woodford"],
  IN: ["Adams", "Allen", "Bartholomew", "Benton", "Blackford", "Boone", "Brown", "Carroll", "Cass", "Clark", "Clay", "Clinton", "Crawford", "Daviess", "Dearborn", "Decatur", "DeKalb", "Delaware", "Dubois", "Elkhart", "Fayette", "Floyd", "Fountain", "Franklin", "Fulton", "Gibson", "Grant", "Greene", "Hamilton", "Hancock", "Harrison", "Hendricks", "Henry", "Howard", "Huntington", "Jackson", "Jasper", "Jay", "Jefferson", "Jennings", "Johnson", "Knox", "Kosciusko", "LaGrange", "Lake", "LaPorte", "Lawrence", "Madison", "Marion", "Marshall", "Martin", "Miami", "Monroe", "Montgomery", "Morgan", "Newton", "Noble", "Ohio", "Orange", "Owen", "Parke", "Perry", "Pike", "Porter", "Posey", "Pulaski", "Putnam", "Randolph", "Ripley", "Rush", "St. Joseph", "Scott", "Shelby", "Spencer", "Starke", "Steuben", "Sullivan", "Switzerland", "Tippecanoe", "Tipton", "Union", "Vanderburgh", "Vermillion", "Vigo", "Wabash", "Warren", "Warrick", "Washington", "Wayne", "Wells", "White", "Whitley"],
  IA: ["Adair", "Adams", "Allamakee", "Appanoose", "Audubon", "Benton", "Black Hawk", "Boone", "Bremer", "Buchanan", "Buena Vista", "Butler", "Calhoun", "Carroll", "Cass", "Cedar", "Cerro Gordo", "Cherokee", "Chickasaw", "Clarke", "Clay", "Clayton", "Clinton", "Crawford", "Dallas", "Davis", "Decatur", "Delaware", "Des Moines", "Dickinson", "Dubuque", "Emmet", "Fayette", "Floyd", "Franklin", "Fremont", "Greene", "Grundy", "Guthrie", "Hamilton", "Hancock", "Hardin", "Harrison", "Henry", "Howard", "Humboldt", "Ida", "Iowa", "Jackson", "Jasper", "Jefferson", "Johnson", "Jones", "Keokuk", "Kossuth", "Lee", "Linn", "Louisa", "Lucas", "Lyon", "Madison", "Mahaska", "Marion", "Marshall", "Mills", "Mitchell", "Monona", "Monroe", "Montgomery", "Muscatine", "O'Brien", "Osceola", "Page", "Palo Alto", "Plymouth", "Pocahontas", "Polk", "Pottawattamie", "Poweshiek", "Ringgold", "Sac", "Scott", "Shelby", "Sioux", "Story", "Tama", "Taylor", "Union", "Van Buren", "Wapello", "Warren", "Washington", "Wayne", "Webster", "Winnebago", "Winneshiek", "Woodbury", "Worth", "Wright"],
  KS: ["Allen", "Anderson", "Atchison", "Barber", "Barton", "Bourbon", "Brown", "Butler", "Chase", "Chautauqua", "Cherokee", "Cheyenne", "Clark", "Clay", "Cloud", "Coffey", "Comanche", "Cowley", "Crawford", "Decatur", "Dickinson", "Doniphan", "Douglas", "Edwards", "Elk", "Ellis", "Ellsworth", "Finney", "Ford", "Franklin", "Geary", "Gove", "Graham", "Grant", "Gray", "Greeley", "Greenwood", "Hamilton", "Harper", "Harvey", "Haskell", "Hodgeman", "Jackson", "Jefferson", "Jewell", "Johnson", "Kearny", "Kingman", "Kiowa", "Labette", "Lane", "Leavenworth", "Lincoln", "Linn", "Logan", "Lyon", "McPherson", "Marion", "Marshall", "Meade", "Miami", "Mitchell", "Montgomery", "Morris", "Morton", "Nemaha", "Neosho", "Ness", "Norton", "Osage", "Osborne", "Ottawa", "Pawnee", "Phillips", "Pottawatomie", "Pratt", "Rawlins", "Reno", "Republic", "Rice", "Riley", "Rooks", "Rush", "Russell", "Saline", "Scott", "Sedgwick", "Seward", "Shawnee", "Sheridan", "Sherman", "Smith", "Stafford", "Stanton", "Stevens", "Sumner", "Thomas", "Trego", "Wabaunsee", "Wallace", "Washington", "Wichita", "Wilson", "Woodson", "Wyandotte"],
  KY: ["Adair", "Allen", "Anderson", "Ballard", "Barren", "Bath", "Bell", "Boone", "Bourbon", "Boyd", "Boyle", "Bracken", "Breathitt", "Breckinridge", "Bullitt", "Butler", "Caldwell", "Calloway", "Campbell", "Carlisle", "Carroll", "Carter", "Casey", "Christian", "Clark", "Clay", "Clinton", "Crittenden", "Cumberland", "Daviess", "Edmonson", "Elliott", "Estill", "Fayette", "Fleming", "Floyd", "Franklin", "Fulton", "Gallatin", "Garrard", "Grant", "Graves", "Grayson", "Green", "Greenup", "Hancock", "Hardin", "Harlan", "Harrison", "Hart", "Henderson", "Henry", "Hickman", "Hopkins", "Jackson", "Jefferson", "Jessamine", "Johnson", "Kenton", "Knott", "Knox", "Larue", "Laurel", "Lawrence", "Lee", "Leslie", "Letcher", "Lewis", "Lincoln", "Livingston", "Logan", "Lyon", "McCracken", "McCreary", "McLean", "Madison", "Magoffin", "Marion", "Marshall", "Martin", "Mason", "Meade", "Menifee", "Mercer", "Metcalfe", "Monroe", "Montgomery", "Morgan", "Muhlenberg", "Nelson", "Nicholas", "Ohio", "Oldham", "Owen", "Owsley", "Pendleton", "Perry", "Pike", "Powell", "Pulaski", "Robertson", "Rockcastle", "Rowan", "Russell", "Scott", "Shelby", "Simpson", "Spencer", "Taylor", "Todd", "Trigg", "Trimble", "Union", "Warren", "Washington", "Wayne", "Webster", "Whitley", "Wolfe", "Woodford"],
  LA: ["Acadia", "Allen", "Ascension", "Assumption", "Avoyelles", "Beauregard", "Bienville", "Bossier", "Caddo", "Calcasieu", "Caldwell", "Cameron", "Catahoula", "Claiborne", "Concordia", "De Soto", "East Baton Rouge", "East Carroll", "East Feliciana", "Evangeline", "Franklin", "Grant", "Iberia", "Iberville", "Jackson", "Jefferson", "Jefferson Davis", "Lafayette", "Lafourche", "LaSalle", "Lincoln", "Livingston", "Madison", "Morehouse", "Natchitoches", "Orleans", "Ouachita", "Plaquemines", "Pointe Coupee", "Rapides", "Red River", "Richland", "Sabine", "St. Bernard", "St. Charles", "St. Helena", "St. James", "St. John the Baptist", "St. Landry", "St. Martin", "St. Mary", "St. Tammany", "Tangipahoa", "Tensas", "Terrebonne", "Union", "Vermilion", "Vernon", "Washington", "Webster", "West Baton Rouge", "West Carroll", "West Feliciana", "Winn"],
  ME: ["Androscoggin", "Aroostook", "Cumberland", "Franklin", "Hancock", "Kennebec", "Knox", "Lincoln", "Oxford", "Penobscot", "Piscataquis", "Sagadahoc", "Somerset", "Waldo", "Washington", "York"],
  MD: ["Allegany", "Anne Arundel", "Baltimore", "Calvert", "Caroline", "Carroll", "Cecil", "Charles", "Dorchester", "Frederick", "Garrett", "Harford", "Howard", "Kent", "Montgomery", "Prince George's", "Queen Anne's", "St. Mary's", "Somerset", "Talbot", "Washington", "Wicomico", "Worcester", "Baltimore City"],
  MA: ["Barnstable", "Berkshire", "Bristol", "Dukes", "Essex", "Franklin", "Hampden", "Hampshire", "Middlesex", "Nantucket", "Norfolk", "Plymouth", "Suffolk", "Worcester"],
  MI: ["Alcona", "Alger", "Allegan", "Alpena", "Antrim", "Arenac", "Baraga", "Barry", "Bay", "Benzie", "Berrien", "Branch", "Calhoun", "Cass", "Charlevoix", "Cheboygan", "Chippewa", "Clare", "Clinton", "Crawford", "Delta", "Dickinson", "Eaton", "Emmet", "Genesee", "Gladwin", "Gogebic", "Grand Traverse", "Gratiot", "Hillsdale", "Houghton", "Huron", "Ingham", "Ionia", "Iosco", "Iron", "Isabella", "Jackson", "Kalamazoo", "Kalkaska", "Kent", "Keweenaw", "Lake", "Lapeer", "Leelanau", "Lenawee", "Livingston", "Luce", "Mackinac", "Macomb", "Manistee", "Marquette", "Mason", "Mecosta", "Menominee", "Midland", "Missaukee", "Monroe", "Montcalm", "Montmorency", "Muskegon", "Newaygo", "Oakland", "Oceana", "Ogemaw", "Ontonagon", "Osceola", "Oscoda", "Otsego", "Ottawa", "Presque Isle", "Roscommon", "Saginaw", "St. Clair", "St. Joseph", "Sanilac", "Schoolcraft", "Shiawassee", "Tuscola", "Van Buren", "Washtenaw", "Wayne", "Wexford"],
  MN: ["Aitkin", "Anoka", "Becker", "Beltrami", "Benton", "Big Stone", "Blue Earth", "Brown", "Carlton", "Carver", "Cass", "Chippewa", "Chisago", "Clay", "Clearwater", "Cook", "Cottonwood", "Crow Wing", "Dakota", "Dodge", "Douglas", "Faribault", "Fillmore", "Freeborn", "Goodhue", "Grant", "Hennepin", "Houston", "Hubbard", "Isanti", "Itasca", "Jackson", "Kanabec", "Kandiyohi", "Kittson", "Koochiching", "Lac qui Parle", "Lake", "Lake of the Woods", "Le Sueur", "Lincoln", "Lyon", "McLeod", "Mahnomen", "Marshall", "Martin", "Meeker", "Mille Lacs", "Morrison", "Mower", "Murray", "Nicollet", "Nobles", "Norman", "Olmsted", "Otter Tail", "Pennington", "Pine", "Pipestone", "Polk", "Pope", "Ramsey", "Red Lake", "Redwood", "Renville", "Rice", "Rock", "Roseau", "St. Louis", "Scott", "Sherburne", "Sibley", "Stearns", "Steele", "Stevens", "Swift", "Todd", "Traverse", "Wabasha", "Wadena", "Waseca", "Washington", "Watonwan", "Wilkin", "Winona", "Wright", "Yellow Medicine"],
  MS: ["Adams", "Alcorn", "Amite", "Attala", "Benton", "Bolivar", "Calhoun", "Carroll", "Chickasaw", "Choctaw", "Claiborne", "Clarke", "Clay", "Coahoma", "Copiah", "Covington", "DeSoto", "Forrest", "Franklin", "George", "Greene", "Grenada", "Hancock", "Harrison", "Hinds", "Holmes", "Humphreys", "Issaquena", "Itawamba", "Jackson", "Jasper", "Jefferson", "Jefferson Davis", "Jones", "Kemper", "Lafayette", "Lamar", "Lauderdale", "Lawrence", "Leake", "Lee", "Leflore", "Lincoln", "Lowndes", "Madison", "Marion", "Marshall", "Monroe", "Montgomery", "Neshoba", "Newton", "Noxubee", "Oktibbeha", "Panola", "Pearl River", "Perry", "Pike", "Pontotoc", "Prentiss", "Quitman", "Rankin", "Scott", "Sharkey", "Simpson", "Smith", "Stone", "Sunflower", "Tallahatchie", "Tate", "Tippah", "Tishomingo", "Tunica", "Union", "Walthall", "Warren", "Washington", "Wayne", "Webster", "Wilkinson", "Winston", "Yalobusha", "Yazoo"],
  MO: ["Adair", "Andrew", "Atchison", "Audrain", "Barry", "Barton", "Bates", "Benton", "Bollinger", "Boone", "Buchanan", "Butler", "Caldwell", "Callaway", "Camden", "Cape Girardeau", "Carroll", "Carter", "Cass", "Cedar", "Chariton", "Christian", "Clark", "Clay", "Clinton", "Cole", "Cooper", "Crawford", "Dade", "Dallas", "Daviess", "DeKalb", "Dent", "Douglas", "Dunklin", "Franklin", "Gasconade", "Gentry", "Greene", "Grundy", "Harrison", "Henry", "Hickory", "Holt", "Howard", "Howell", "Iron", "Jackson", "Jasper", "Jefferson", "Johnson", "Knox", "Laclede", "Lafayette", "Lawrence", "Lewis", "Lincoln", "Linn", "Livingston", "McDonald", "Macon", "Madison", "Maries", "Marion", "Mercer", "Miller", "Mississippi", "Moniteau", "Monroe", "Montgomery", "Morgan", "New Madrid", "Newton", "Nodaway", "Oregon", "Osage", "Ozark", "Pemiscot", "Perry", "Pettis", "Phelps", "Pike", "Platte", "Polk", "Pulaski", "Putnam", "Ralls", "Randolph", "Ray", "Reynolds", "Ripley", "Saline", "Schuyler", "Scotland", "Scott", "Shannon", "Shelby", "St. Charles", "St. Clair", "St. Francois", "St. Louis", "St. Louis City", "Ste. Genevieve", "Stoddard", "Stone", "Sullivan", "Taney", "Texas", "Vernon", "Warren", "Washington", "Wayne", "Webster", "Worth", "Wright"],
  MT: ["Beaverhead", "Big Horn", "Blaine", "Broadwater", "Carbon", "Carter", "Cascade", "Chouteau", "Custer", "Daniels", "Dawson", "Deer Lodge", "Fallon", "Fergus", "Flathead", "Gallatin", "Garfield", "Glacier", "Golden Valley", "Granite", "Hill", "Jefferson", "Judith Basin", "Lake", "Lewis and Clark", "Liberty", "Lincoln", "McCone", "Madison", "Meagher", "Mineral", "Missoula", "Musselshell", "Park", "Petroleum", "Phillips", "Pondera", "Powder River", "Powell", "Prairie", "Ravalli", "Richland", "Roosevelt", "Rosebud", "Sanders", "Sheridan", "Silver Bow", "Stillwater", "Sweet Grass", "Teton", "Toole", "Treasure", "Valley", "Wheatland", "Wibaux", "Yellowstone"],
  NE: ["Adams", "Antelope", "Arthur", "Banner", "Blaine", "Boone", "Box Butte", "Boyd", "Brown", "Buffalo", "Burt", "Butler", "Cass", "Cedar", "Chase", "Cherry", "Cheyenne", "Clay", "Colfax", "Cuming", "Custer", "Dakota", "Dawes", "Dawson", "Deuel", "Dixon", "Dodge", "Douglas", "Dundy", "Fillmore", "Franklin", "Frontier", "Furnas", "Gage", "Garden", "Garfield", "Gosper", "Grant", "Greeley", "Hall", "Hamilton", "Harlan", "Hayes", "Hitchcock", "Holt", "Hooker", "Howard", "Jefferson", "Johnson", "Kearney", "Keith", "Keya Paha", "Kimball", "Knox", "Lancaster", "Lincoln", "Logan", "Loup", "McPherson", "Madison", "Merrick", "Morrill", "Nance", "Nemaha", "Nuckolls", "Otoe", "Pawnee", "Perkins", "Phelps", "Pierce", "Platte", "Polk", "Red Willow", "Richardson", "Rock", "Saline", "Sarpy", "Saunders", "Scotts Bluff", "Seward", "Sheridan", "Sherman", "Sioux", "Stanton", "Thayer", "Thomas", "Thurston", "Valley", "Washington", "Wayne", "Webster", "Wheeler", "York"],
  NV: ["Carson City", "Churchill", "Clark", "Douglas", "Elko", "Esmeralda", "Eureka", "Humboldt", "Lander", "Lincoln", "Lyon", "Mineral", "Nye", "Pershing", "Storey", "Washoe", "White Pine"],
  NH: ["Belknap", "Carroll", "Cheshire", "Coos", "Grafton", "Hillsborough", "Merrimack", "Rockingham", "Strafford", "Sullivan"],
  NJ: ["Atlantic", "Bergen", "Burlington", "Camden", "Cape May", "Cumberland", "Essex", "Gloucester", "Hudson", "Hunterdon", "Mercer", "Middlesex", "Monmouth", "Morris", "Ocean", "Passaic", "Salem", "Somerset", "Sussex", "Union", "Warren"],
  NM: ["Bernalillo", "Catron", "Chaves", "Cibola", "Colfax", "Curry", "De Baca", "Dona Ana", "Eddy", "Grant", "Guadalupe", "Harding", "Hidalgo", "Lea", "Lincoln", "Los Alamos", "Luna", "McKinley", "Mora", "Otero", "Quay", "Rio Arriba", "Roosevelt", "Sandoval", "San Juan", "San Miguel", "Santa Fe", "Sierra", "Socorro", "Taos", "Torrance", "Union", "Valencia"],
  NY: ["Albany", "Allegany", "Bronx", "Broome", "Cattaraugus", "Cayuga", "Chautauqua", "Chemung", "Chenango", "Clinton", "Columbia", "Cortland", "Delaware", "Dutchess", "Erie", "Essex", "Franklin", "Fulton", "Genesee", "Greene", "Hamilton", "Herkimer", "Jefferson", "Kings", "Lewis", "Livingston", "Madison", "Monroe", "Montgomery", "Nassau", "New York", "Niagara", "Oneida", "Onondaga", "Ontario", "Orange", "Orleans", "Oswego", "Otsego", "Putnam", "Queens", "Rensselaer", "Richmond", "Rockland", "St. Lawrence", "Saratoga", "Schenectady", "Schoharie", "Schuyler", "Seneca", "Steuben", "Suffolk", "Sullivan", "Tioga", "Tompkins", "Ulster", "Warren", "Washington", "Wayne", "Westchester", "Wyoming", "Yates"],
  NC: ["Alamance", "Alexander", "Alleghany", "Anson", "Ashe", "Avery", "Beaufort", "Bertie", "Bladen", "Brunswick", "Buncombe", "Burke", "Cabarrus", "Caldwell", "Camden", "Carteret", "Caswell", "Catawba", "Chatham", "Cherokee", "Chowan", "Clay", "Cleveland", "Columbus", "Craven", "Cumberland", "Currituck", "Dare", "Davidson", "Davie", "Duplin", "Durham", "Edgecombe", "Forsyth", "Franklin", "Gaston", "Gates", "Graham", "Granville", "Greene", "Guilford", "Halifax", "Harnett", "Haywood", "Henderson", "Hertford", "Hoke", "Hyde", "Iredell", "Jackson", "Johnston", "Jones", "Lee", "Lenoir", "Lincoln", "McDowell", "Macon", "Madison", "Martin", "Mecklenburg", "Mitchell", "Montgomery", "Moore", "Nash", "New Hanover", "Northampton", "Onslow", "Orange", "Pamlico", "Pasquotank", "Pender", "Perquimans", "Person", "Pitt", "Polk", "Randolph", "Richmond", "Robeson", "Rockingham", "Rowan", "Rutherford", "Sampson", "Scotland", "Stanly", "Stokes", "Surry", "Swain", "Transylvania", "Tyrrell", "Union", "Vance", "Wake", "Warren", "Washington", "Watauga", "Wayne", "Wilkes", "Wilson", "Yadkin", "Yancey"],
  ND: ["Adams", "Barnes", "Benson", "Billings", "Bottineau", "Bowman", "Burke", "Burleigh", "Cass", "Cavalier", "Dickey", "Divide", "Dunn", "Eddy", "Emmons", "Foster", "Golden Valley", "Grand Forks", "Grant", "Griggs", "Hettinger", "Kidder", "LaMoure", "Logan", "McHenry", "McIntosh", "McKenzie", "McLean", "Mercer", "Morton", "Mountrail", "Nelson", "Oliver", "Pembina", "Pierce", "Ramsey", "Ransom", "Renville", "Richland", "Rolette", "Sargent", "Sheridan", "Sioux", "Slope", "Stark", "Steele", "Stutsman", "Towner", "Traill", "Walsh", "Ward", "Wells", "Williams"],
  OH: ["Adams", "Allen", "Ashland", "Ashtabula", "Athens", "Auglaize", "Belmont", "Brown", "Butler", "Carroll", "Champaign", "Clark", "Clermont", "Clinton", "Columbiana", "Coshocton", "Crawford", "Cuyahoga", "Darke", "Defiance", "Delaware", "Erie", "Fairfield", "Fayette", "Franklin", "Gallia", "Geauga", "Greene", "Guernsey", "Hamilton", "Hancock", "Hardin", "Harrison", "Henry", "Highland", "Hocking", "Holmes", "Huron", "Jackson", "Jefferson", "Knox", "Lake", "Lawrence", "Licking", "Logan", "Lorain", "Lucas", "Madison", "Mahoning", "Marion", "Medina", "Meigs", "Monroe", "Montgomery", "Morgan", "Morrow", "Muskingum", "Noble", "Ottawa", "Paulding", "Perry", "Pickaway", "Pike", "Portage", "Preble", "Putnam", "Richland", "Ross", "Sandusky", "Scioto", "Seneca", "Shelby", "Stark", "Summit", "Trumbull", "Tuscarawas", "Union", "Vinton", "Warren", "Washington", "Wayne", "Wood", "Wyandot"],
  OK: ["Adair", "Alfalfa", "Atoka", "Beaver", "Beckham", "Blaine", "Bryan", "Caddo", "Canadian", "Carter", "Cherokee", "Choctaw", "Cimarron", "Cleveland", "Coal", "Comanche", "Cotton", "Craig", "Creek", "Custer", "Delaware", "Dewey", "Ellis", "Garfield", "Garvin", "Grady", "Grant", "Greer", "Harmon", "Harper", "Haskell", "Hughes", "Jackson", "Jefferson", "Johnston", "Kay", "Kingfisher", "Kiowa", "Latimer", "Le Flore", "Lincoln", "Logan", "Love", "Major", "Marshall", "Mayes", "Murray", "Muskogee", "Noble", "Nowata", "Oklahoma", "Okmulgee", "Osage", "Ottawa", "Pawnee", "Payne", "Pittsburg", "Pontotoc", "Pottawatomie", "Pushmataha", "Roger Mills", "Rogers", "Seminole", "Sequoyah", "Stephens", "Texas", "Tillman", "Tulsa", "Wagoner", "Washington", "Washita", "Woods", "Woodward"],
  OR: ["Baker", "Benton", "Clackamas", "Clatsop", "Columbia", "Coos", "Crook", "Curry", "Deschutes", "Douglas", "Gilliam", "Grant", "Harney", "Hood River", "Jackson", "Jefferson", "Josephine", "Klamath", "Lake", "Lane", "Lincoln", "Linn", "Malheur", "Marion", "Morrow", "Multnomah", "Polk", "Sherman", "Tillamook", "Umatilla", "Union", "Wallowa", "Wasco", "Washington", "Wheeler", "Yamhill"],
  PA: ["Adams", "Allegheny", "Armstrong", "Beaver", "Bedford", "Berks", "Blair", "Bradford", "Bucks", "Butler", "Cambria", "Cameron", "Carbon", "Centre", "Chester", "Clarion", "Clearfield", "Clinton", "Columbia", "Crawford", "Dauphin", "Delaware", "Elk", "Erie", "Fayette", "Forest", "Franklin", "Fulton", "Greene", "Huntingdon", "Indiana", "Jefferson", "Juniata", "Lackawanna", "Lancaster", "Lawrence", "Lebanon", "Lehigh", "Luzerne", "Lykens", "Monroe", "Montgomery", "Montour", "Northampton", "Northumberland", "Perry", "Philadelphia", "Pike", "Potter", "Schuylkill", "Snyder", "Somerset", "Sullivan", "Susquehanna", "Tioga", "Union", "Venango", "Warren", "Washington", "Wayne", "Westmoreland", "Wyoming", "York"],
  RI: ["Bristol", "Kent", "Newport", "Providence", "Washington"],
  SC: ["Abbeville", "Aiken", "Allendale", "Anderson", "Bamberg", "Barnwell", "Beaufort", "Berkeley", "Calhoun", "Charleston", "Cherokee", "Chester", "Chesterfield", "Clarendon", "Colleton", "Darlington", "Dillon", "Dorchester", "Edgefield", "Fairfield", "Florence", "Georgetown", "Greenville", "Greenwood", "Hampton", "Horry", "Jasper", "Kershaw", "Lancaster", "Laurens", "Lee", "Lexington", "McCormick", "Marion", "Marlboro", "Newberry", "Oconee", "Orangeburg", "Pickens", "Richland", "Saluda", "Spartanburg", "Sumter", "Union", "Williamsburg", "York"],
  SD: ["Aurora", "Beadle", "Benet", "Bon Homme", "Brookings", "Brown", "Brule", "Buffalo", "Campbell", "Charles Mix", "Clark", "Clay", "Codington", "Corson", "Custer", "Davison", "Day", "Deuel", "Dewey", "Douglas", "Edmunds", "Fall River", "Faulk", "Grant", "Gregory", "Haakon", "Hamlin", "Hand", "Hanson", "Harding", "Hughes", "Hutchinson", "Jackson", "Jerauld", "Jones", "Kingsbury", "Lake", "Lawrence", "Lincoln", "Lyman", "McCook", "McPherson", "Marshall", "Meade", "Mellette", "Miner", "Minnehaha", "Moody", "Oglala Lakota", "Pennington", "Perkins", "Potter", "Roberts", "Sanborn", "Shannon", "Spink", "Stanley", "Sully", "Todd", "Tripp", "Turner", "Union", "Walworth", "Yankton", "Ziebach"],
  TN: ["Anderson", "Bedford", "Benton", "Bledsoe", "Blount", "Bradley", "Campbell", "Cannon", "Carroll", "Carter", "Cheatham", "Chester", "Claiborne", "Clay", "Cocke", "Coffee", "Decatur", "DeKalb", "Dickson", "Dyer", "Fayette", "Fentress", "Franklin", "Gibson", "Giles", "Grainger", "Greene", "Grundy", "Hamblen", "Hamilton", "Hancock", "Hardeman", "Hardin", "Hawkins", "Haywood", "Henderson", "Henry", "Hickman", "Houston", "Humphreys", "Jackson", "James", "Jefferson", "Johnson", "Knox", "Lake", "Lauderdale", "Lawrence", "Lewis", "Lincoln", "Loudon", "McMinn", "McNairy", "Macon", "Madison", "Marion", "Marshall", "Maury", "Meigs", "Monroe", "Montgomery", "Moore", "Morgan", "Obion", "Overton", "Perry", "Pickett", "Polk", "Putnam", "Rhea", "Roane", "Robertson", "Rutherford", "Scott", "Sequatchie", "Sevier", "Shelby", "Smith", "Stewart", "Sullivan", "Sumner", "Tipton", "Trousdale", "Unicoi", "Union", "Van Buren", "Warren", "Washington", "Wayne", "Weakley", "White", "Williamson", "Wilson"],
  TX: ["Anderson", "Andrews", "Angelina", "Aransas", "Armstrong", "Atascosa", "Austin", "Bailey", "Bandera", "Bastrop", "Baylor", "Bee", "Bell", "Bexar", "Blanco", "Bowie", "Brazoria", "Brazos", "Brewster", "Briscoe", "Brooks", "Brown", "Burleson", "Burnet", "Caldwell", "Callahan", "Cameron", "Camp", "Carson", "Cass", "Chambers", "Cherokee", "Clay", "Cochran", "Coke", "Coleman", "Collin", "Collingsworth", "Colorado", "Comal", "Cooke", "Coryell", "Cottle", "Crane", "Crockett", "Crosby", "Dallam", "Dallas", "Dawson", "Deaf Smith", "Delta", "Denton", "DeWitt", "Dickens", "Dimmit", "Duncan", "Ector", "Edwards", "El Paso", "Ellis", "Erath", "Falls", "Fannin", "Fayette", "Fisher", "Floyd", "Foard", "Fort Bend", "Francis", "Freestone", "Frio", "Gaines", "Galveston", "Garza", "Gillespie", "Glasscock", "Goliad", "Gonzales", "Gray", "Grayson", "Gregg", "Grimes", "Guadalupe", "Hale", "Hall", "Haskell", "Harrison", "Hartley", "Hays", "Hemphill", "Henderson", "Hidalgo", "Hill", "Hockley", "Hood", "Hopkins", "Houston", "Howard", "Hudspeth", "Hunt", "Johnson", "Jones", "Kaufman", "Kendall", "Kenedy", "Kent", "Kerr", "Kimble", "King", "Kinney", "Kleberg", "Knox", "Lamar", "Lampasas", "La Salle", "Lavaca", "Lee", "Leon", "Liberty", "Limestone", "Lipscomb", "Live Oak", "Llano", "Loving", "Lubbock", "Lynn", "McCulloch", "McLennan", "McMullen", "Madison", "Marion", "Martin", "Mason", "Matagorda", "Maverick", "Medina", "Menard", "Midland", "Milam", "Mills", "Mitchell", "Montague", "Montgomery", "Moore", "Morris", "Nacogdoches", "Navarro", "Newton", "Nolan", "Nueces", "Ochiltree", "Oldham", "Orange", "Palo Pinto", "Panola", "Parker", "Parmer", "Pecos", "Polk", "Potter", "Presidio", "Rains", "Randall", "Reagan", "Real", "Red River", "Reeves", "Refugio", "Roberts", "Robertson", "Rockwall", "Runnels", "Rusk", "Sabine", "San Augustine", "San Jacinto", "San Patricio", "San Saba", "Schleicher", "Smith", "Somervell", "Starr", "Stephens", "Sterling", "Stonewall", "Sutton", "Swisher", "Tarrant", "Taylor", "Terrell", "Terry", "Throckmorton", "Titus", "Tom Green", "Travis", "Trinity", "Tyler", "Upshur", "Upton", "Val Verde", "Van Zandt", "Victoria", "Walker", "Waller", "Ward", "Washington", "Webb", "Wharton", "Wheeler", "Williamson", "Wilson", "Winkler", "Wise", "Wood", "Yoakum", "Young", "Zapata", "Zavala"],
  UT: ["Beaver", "Box Elder", "Cache", "Carbon", "Daggett", "Davis", "Duchesne", "Emery", "Garfield", "Grand", "Iron", "Juab", "Kane", "Millard", "Morgan", "Piute", "Rich", "Salt Lake", "San Juan", "Sanpete", "Sevier", "Summit", "Tooele", "Uintah", "Utah", "Wasatch", "Washington", "Wayne", "Weber"],
  VT: ["Addison", "Bennington", "Caledonia", "Chittenden", "Essex", "Franklin", "Grand Isle", "Lamoille", "Orange", "Orleans", "Rutland", "Washington", "Windsor", "Windham"],
  VA: ["Accomack", "Albemarle", "Alleghany", "Amelia", "Amherst", "Appomattox", "Arlington", "Augusta", "Bath", "Bedford", "Bland", "Botetourt", "Brunswick", "Buchanan", "Buckingham", "Campbell", "Caroline", "Carroll", "Charles City", "Charlotte", "Chesterfield", "Clarke", "Craig", "Culpeper", "Dickenson", "Dinwiddie", "Essex", "Fairfax", "Fauquier", "Floyd", "Fluvanna", "Franklin", "Frederick", "Giles", "Gloucester", "Greene", "Greensville", "Halifax", "Hanover", "Harrison", "Henrico", "Henry", "Highland", "Isle of Wight", "James City", "King and Queen", "King George", "King William", "Lancaster", "Lee", "Loudoun", "Louisa", "Lunenburg", "Madison", "Mathews", "Mecklenburg", "Middlesex", "Montgomery", "Nelson", "New Kent", "Northampton", "Northumberland", "Nottoway", "Orange", "Page", "Patrick", "Pittsylvania", "Powhatan", "Prince Edward", "Prince George", "Prince William", "Pulaski", "Rappahannock", "Richmond", "Roanoke", "Rockbridge", "Rockingham", "Russell", "Scott", "Shenandoah", "Smyth", "Southampton", "Spotsylvania", "Stafford", "Surry", "Sussex", "Tazewell", "Warren", "Washington", "Westmoreland", "Wise", "Wythe", "York"],
  WA: ["Adams", "Asotin", "Benton", "Chelan", "Clallam", "Clark", "Columbia", "Cowlitz", "Douglas", "Ferry", "Franklin", "Garfield", "Grant", "Grays Harbor", "Island", "Jefferson", "King", "Kitsap", "Kittitas", "Klickitat", "Lewis", "Lincoln", "Mason", "Okanogan", "Pacific", "Pend Oreille", "Pierce", "San Juan", "Skagit", "Skamania", "Snohomish", "Spokane", "Stevens", "Thurston", "Wahkiakum", "Walla Walla", "Whatcom", "Whitman", "Yakima"],
  WI: ["Adams", "Ashland", "Barron", "Bayfield", "Brown", "Buffalo", "Burnett", "Calumet", "Chippewa", "Clark", "Columbia", "Crawford", "Dane", "Dodge", "Door", "Douglas", "Dunn", "Eau Claire", "Florence", "Fond du Lac", "Forest", "Grant", "Green", "Green Lake", "Iowa", "Iron", "Jackson", "Jefferson", "Juneau", "Kenosha", "Kewaunee", "La Crosse", "Lafayette", "Langlade", "Lincoln", "Manitowoc", "Marathon", "Marinette", "Marquette", "Menominee", "Milwaukee", "Monroe", "Oconto", "Oneida", "Outagamie", "Ozaukee", "Pepin", "Pierce", "Polk", "Portage", "Price", "Racine", "Richland", "Rock", "Rusk", "St. Croix", "Sauk", "Sawyer", "Shawano", "Sheboygan", "Taylor", "Trempealeau", "Vernon", "Vilas", "Walworth", "Washburn", "Washington", "Waukesha", "Waupaca", "Waushara", "Winnebago", "Wood"],
  WV: ["Barbour", "Berkeley", "Boone", "Braxton", "Brooke", "Cabell", "Calhoun", "Clay", "Doddridge", "Fayette", "Gilmer", "Grant", "Greenbrier", "Hampshire", "Hancock", "Hardy", "Harrison", "Jackson", "Jefferson", "Kanawha", "Lewis", "Lincoln", "Logan", "Marion", "Marshall", "Mason", "McDowell", "Mercer", "Mineral", "Mingo", "Monongalia", "Monroe", "Morgan", "Nicholas", "Ohio", "Pendleton", "Pleasants", "Pocahontas", "Preston", "Putnam", "Raleigh", "Randolph", "Ritchie", "Roane", "Summers", "Taylor", "Tucker", "Tyler", "Upshur", "Wayne", "Webster", "Wetzel", "Wirt", "Wood", "Wyoming"],
  WY: ["Albany", "Big Horn", "Campbell", "Carbon", "Converse", "Crook", "Fremont", "Goshen", "Hot Springs", "Johnson", "Laramie", "Lincoln", "Natrona", "Niobrara", "Park", "Platte", "Sheridan", "Sublette", "Sweetwater", "Teton", "Uinta", "Washakie", "Weston"],
  DC: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5", "Ward 6", "Ward 7", "Ward 8" ],
  PR: ["Adjuntas", "Aguada", "Aguadilla", "Aguas Buenas", "Aibonito", "Anasco", "Arecibo", "Arroyo", "Barceloneta", "Barranquitas", "Bayamon", "Cabo Rojo", "Caguas", "Campanilla", "Canovanas", "Carolina", "Catano", "Cayey", "Ceiba", "Ciales", "Cidra", "Coamo", "Comerio", "Corozal", "Fajardo", "Florida", "Gurabo", "Guayama", "Guayanilla", "Guaynabo", "Hatillo", "Hormigueros", "Humacao", "Isabela", "Jayuya", "Juncos", "Lajas", "Lares", "Las Marias", "Las Piedras", "Loiza", "Luquillo", "Manati", "Maricao", "Mayaguez", "Moca", "Morovis", "Naguabo", "Naranjito", "Orocovis", "Penuelas", "Ponce", "Quebradillas", "Rincon", "Rio Grande", "Sabana Grande", "Salinas", "San German", "San Juan", "San Lorenzo", "San Sebastian", "Santa Isabel", "Toa Alta", "Toa Baja", "Trujillo Alto", "Utuado", "Vega Alta", "Vega Baja", "Vieques", "Villalba", "Yabucoa", "Yauco"]
};



type StateEnumType = {
  fullName: string;
  abbreviation: string;
  flagIcon: string
};

export const USStatesEnum: { [key: string]: StateEnumType } = {
  AL: { fullName: "Alabama", abbreviation: "AL", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Alabama.svg" },
  AK: { fullName: "Alaska", abbreviation: "AK", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Flag_of_Alaska.svg"},
  AZ: { fullName: "Arizona", abbreviation: "AZ", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Flag_of_Arizona.svg" },
  AR: { fullName: "Arkansas", abbreviation: "AR", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Flag_of_Arkansas.svg" },
  CA: { fullName: "California", abbreviation: "CA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_California.svg" },
  CO: { fullName: "Colorado", abbreviation: "CO", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/4/46/Flag_of_Colorado.svg" },
  CT: { fullName: "Connecticut", abbreviation: "CT", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/9/96/Flag_of_Connecticut.svg" },
  DC: { fullName: "District Of Columbia", abbreviation: "DC", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Washington%2C_D.C.svg"},
  DE: { fullName: "Delaware", abbreviation: "DE", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/c/c6/Flag_of_Delaware.svg" },
  FL: { fullName: "Florida", abbreviation: "FL", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Flag_of_Florida.svg" },
  GA: { fullName: "Georgia", abbreviation: "GA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/0/08/Flag_of_the_State_of_Georgia.svg" },
  HI: { fullName: "Hawaii", abbreviation: "HI", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/e/ef/Flag_of_Hawaii.svg" },
  ID: { fullName: "Idaho", abbreviation: "ID", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_Idaho.svg" },
  IL: { fullName: "Illinois", abbreviation: "IL", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Illinois.svg" },
  IN: { fullName: "Indiana", abbreviation: "IN", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/a/ac/Flag_of_Indiana.svg" },
  IA: { fullName: "Iowa", abbreviation: "IA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Flag_of_Iowa.svg" },
  KS: { fullName: "Kansas", abbreviation: "KS", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/d/da/Flag_of_Kansas.svg" },
  KY: { fullName: "Kentucky", abbreviation: "KY", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/8/8d/Flag_of_Kentucky.svg" },
  LA: { fullName: "Louisiana", abbreviation: "LA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Flag_of_Louisiana.svg" },
  ME: { fullName: "Maine", abbreviation: "ME", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/3/35/Flag_of_Maine.svg" },
  MD: { fullName: "Maryland", abbreviation: "MD", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/a/a0/Flag_of_Maryland.svg" },
  MA: { fullName: "Massachusetts", abbreviation: "MA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Flag_of_Massachusetts.svg" },
  MI: { fullName: "Michigan", abbreviation: "MI", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/b/b5/Flag_of_Michigan.svg" },
  MN: { fullName: "Minnesota", abbreviation: "MN", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Minnesota.svg" },
  MS: { fullName: "Mississippi", abbreviation: "MS", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/4/42/Flag_of_Mississippi.svg" },
  MO: { fullName: "Missouri", abbreviation: "MO", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/5/5a/Flag_of_Missouri.svg" },
  MT: { fullName: "Montana", abbreviation: "MT", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_Montana.svg" },
  NE: { fullName: "Nebraska", abbreviation: "NE", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/4/4d/Flag_of_Nebraska.svg" },
  NV: { fullName: "Nevada", abbreviation: "NV", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Flag_of_Nevada.svg" },
  NH: { fullName: "New Hampshire", abbreviation: "NH", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/2/28/Flag_of_New_Hampshire.svg" },
  NJ: { fullName: "New Jersey", abbreviation: "NJ", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/9/92/Flag_of_New_Jersey.svg" },
  NM: { fullName: "New Mexico", abbreviation: "NM", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_New_Mexico.svg" },
  NY: { fullName: "New York", abbreviation: "NY", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_New_York.svg" },
  NC: { fullName: "North Carolina", abbreviation: "NC", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/b/bb/Flag_of_North_Carolina.svg" },
  ND: { fullName: "North Dakota", abbreviation: "ND", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/e/ee/Flag_of_North_Dakota.svg" },
  OH: { fullName: "Ohio", abbreviation: "OH", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Flag_of_Ohio.svg" },
  OK: { fullName: "Oklahoma", abbreviation: "OK", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/6/6e/Flag_of_Oklahoma.svg" },
  OR: { fullName: "Oregon", abbreviation: "OR", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Oregon.svg" },
  PA: { fullName: "Pennsylvania", abbreviation: "PA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Flag_of_Pennsylvania.svg" },
  PR: { fullName: "Puerto Rico", abbreviation: "PR", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/2/28/Flag_of_Puerto_Rico.svg" },
  RI: { fullName: "Rhode Island", abbreviation: "RI", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Rhode_Island.svg" },
  SC: { fullName: "South Carolina", abbreviation: "SC", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/6/69/Flag_of_South_Carolina.svg" },
  SD: { fullName: "South Dakota", abbreviation: "SD", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_South_Dakota.svg" },
  TN: { fullName: "Tennessee", abbreviation: "TN", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/9/9e/Flag_of_Tennessee.svg" },
  TX: { fullName: "Texas", abbreviation: "TX", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Flag_of_Texas.svg" },
  UT: { fullName: "Utah", abbreviation: "UT", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/f/f6/Flag_of_Utah.svg" },
  VT: { fullName: "Vermont", abbreviation: "VT", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Vermont.svg" },
  VA: { fullName: "Virginia", abbreviation: "VA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/4/47/Flag_of_Virginia.svg" },
  WA: { fullName: "Washington", abbreviation: "WA", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/5/54/Flag_of_Washington.svg" },
  WV: { fullName: "West Virginia", abbreviation: "WV", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/2/22/Flag_of_West_Virginia.svg" },
  WI: { fullName: "Wisconsin", abbreviation: "WI", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/2/22/Flag_of_Wisconsin.svg" },
  WY: { fullName: "Wyoming", abbreviation: "WY", flagIcon: "https://upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Wyoming.svg" }
};


export enum MeasurementUnits {
  // Weight
  kg = "KILOGRAM",
  g = "GRAM",
  mg = "MILLIGRAM",
  ug = "MICROGRAM",
  mcg = "MICROGRAM",
  t = "METRIC TON",
  lb = "POUND",
  oz = "OUNCE",
  st = "STONE",
  short_ton = "SHORT TON",
  long_ton = "LONG TON",
  ct = "CARAT",
  dram = "DRAM",
  // Count
  ea = "EACH",
  unit = "UNIT",
  pr = "PAIR",
  doz = "DOZEN",
  set = "SET",
  pkg = "PACKAGE",
  pack = "PACK",
  box = "BOX",
  case = "CASE",
  roll = "ROLL",
  sheet = "SHEET",
  bag = "BAG",
  bottle = "BOTTLE",
  can = "CAN",
  bunch = "BUNCH",
  slice = "SLICE",
  loaf = "LOAF",
  head = "HEAD",
  clove = "CLOVE",
  sprig = "SPRIG",
  stalk = "STALK",
  fillet = "FILLET",
  serving = "SERVING",
  portion = "PORTION",
  stick = "STICK",
  // Volume
  L = "LITER",
  mL = "MILLILITER",
  cL = "CENTILITER",
  dL = "DECILITER",
  hL = "HECTOLITER",
  kL = "KILOLITER",
  m3 = "CUBIC METER",
  cm3 = "CUBIC CENTIMETER",
  mm3 = "CUBIC MILLIMETER",
  gal = "GALLON",
  gal_imp = "IMPERIAL GALLON",
  qt = "QUART",
  pt = "PINT",
  cup = "CUP",
  fl_oz = "FLUID OUNCE",
  tbsp = "TABLESPOON",
  tsp = "TEASPOON",
  bbl = "BARREL",
  bushel = "BUSHEL",
  peck = "PECK",
  drop = "DROP",
  pinch = "PINCH",
  dash = "DASH",
  smidgen = "SMIDGEN",
  // Length
  km = "KILOMETER",
  m = "METER",
  dm = "DECIMETER",
  cm = "CENTIMETER",
  mm = "MILLIMETER",
  um = "MICROMETER",
  nm = "NANOMETER",
  mi = "MILE",
  nmi = "NAUTICAL MILE",
  in_ = "INCH",
  ft = "FOOT",
  yd = "YARD",
  // Area
  m2 = "SQUARE METER",
  cm2 = "SQUARE CENTIMETER",
  ft2 = "SQUARE FOOT",
  in2 = "SQUARE INCH",
  ha = "HECTARE",
  acre = "ACRE",
  // Time
  ms = "MILLISECOND",
  sec = "SECOND",
  min = "MINUTE",
  hr = "HOUR",
  day = "DAY",
  week = "WEEK",
  month = "MONTH",
  year = "YEAR",
  session = "SESSION",
  // Temperature
  C = "CELSIUS",
  F = "FAHRENHEIT",
  K = "KELVIN",
  // Energy / Power
  W = "WATT",
  kW = "KILOWATT",
  kWh = "KILOWATT HOUR",
  J = "JOULE",
  cal = "CALORIE",
  kcal = "KILOCALORIE",
}

/** Short unit codes stored on inventory (enum keys, e.g. "hr" — not enum values like "HOUR"). */
export type MeasurementUnitCode = keyof typeof MeasurementUnits;

export const TIME_MEASUREMENT_UNIT_CODES = [
  "ms",
  "sec",
  "min",
  "hr",
  "day",
  "week",
  "month",
  "year",
  "session",
] as const satisfies readonly MeasurementUnitCode[];

export type TimeMeasurementUnitCode = (typeof TIME_MEASUREMENT_UNIT_CODES)[number];


export enum InventoryCategories {
  // Kitchen Equipment, Tools and Utensils
  equipment = "Kitchen Equipment",
  utensils = "Utensils",
  appliances = "Appliances",
  // Cleaning Supplies
  cleaning = "Cleaning Supplies",
  // Packaging
  packaging = "Packaging",
  // Disposables
  disposables = "Disposables",
  // Vegetables, Grains and Pasta
  vegetables = "Vegetables",
  fruits = "Fruits",
  grains = "Grains",
  pasta = "Pasta",
  // Dairy and Meat
  dairy = "Dairy",
  meat = "Meat",
  poultry = "Poultry",
  seafood = "Seafood",
  // Breads and Bakery
  bread = "Bread",
  bakery = "Bakery",
  // Beverages
  beverages = "Beverages",
  alcohol = "Alcohol",
  // Snacks
  snacks = "Snacks",
  // Spices and Herbs
  spices = "Spices",
  herbs = "Herbs",
  // Condiments and Sauces
  condiments = "Condiments",
  sauces = "Sauces",
  // Oils and Fats
  oils = "Oils",
  fats = "Fats",
  // Sweets and Desserts
  sweets = "Sweets",
  desserts = "Desserts",
  // Frozen Foods
  frozen = "Frozen Foods",
  // Canned and Jarred
  canned = "Canned Goods",
  jarred = "Jarred Goods",
  // Baking Supplies
  baking = "Baking Supplies",
  // Miscellaneous
  miscellaneous = "Miscellaneous",
}


const kitchenStatuses = () => {
  return {
    0: { value: "created", label: "Created" },
    10: { value: "pending", label: "Pending" },
    20: { value: "confirmed", label: "Confirmed" },
    30: { value: "canceled", label: "Canceled" },
    40: { value: "completed", label: "Completed" },
  };
};

const membershipStatuses = () => {
  return {
    0: { value: "created", label: "Created" },
    10: { value: "pending", label: "Pending" },
    20: { value: "confirmed", label: "Confirmed" },
    30: { value: "canceled", label: "Canceled" },
    40: { value: "completed", label: "Completed" },
  };
};

const statusColors = () => {
  return {
    Pending: "bg-gray-500",
    Created: "bg-green-500",
    Confirmed: "bg-yellow-400",
    Canceled: "bg-red-600",
    Completed: "bg-primaryDark-400",
  };
};

type PreferenceSettingsType = {
  [key: string]: {
    category: 'Experience' | 'Kitchen' | 'Location' | 'Booking' | 'Miscellaneous'
    questions: {
      [key: number]: {
        title: string
      }
    }
  }
}

const preferenceSettings: PreferenceSettingsType = {
    step1: {
      category: "Experience",
      questions: {
        1: {
          title: "Ownership of Kitchen",
        },
        2: {
          title: "How long have you owned you kitchen?",
        },
      },
    },
    step2: {
      category: "Kitchen",
      questions: {
        1: {
          title:
            "Primary equipment you need to cook for you business.",
        },
        2: {
          title:
            "Community Type",
        },
      },
    },
    step3: {
      category: "Location",
      questions: {
        1: {
          title:
            "Address / City / State / Zip Code of your kitchen",
        },
        2: {
          title:
            "Size of Kitchen Space",
        },
        
      },
    },
    step4: {
      category: "Booking",
      questions: {
        1: {
          title:
            "Urgency for Booking",
        },
        2: {
          title:
            "Kitchen Availability",
        },
      },
    }
  };

type QuestionaireType = {
  [key: string]: {
    question: string;
    preferenceCategory: 'Experience' | 'Kitchen' | 'Location' | 'Booking' | 'Miscellaneous'
    options: {
      [key: number]: string;
    };
  };
}

const questionaire : QuestionaireType = {
  step1 : {
    question: "Are you the sole owner of the kitchen?",
    preferenceCategory: "Experience",
    options: {
      1: "Yes, I'm a sole owner",
      2: "No, I have partners",
      3: "other",
    }
  },
  step2 : {
    question: "How long have you owned your kitchen?",
    preferenceCategory: "Experience",
    options: {
      1: "Less than 1 year",
      2: "1-3 years",
      3: "5+ years",
      4: "I do not own the kitchen, I lease it",
      5: "Prospective owner"
    }
  },
  step3 : {
    question: "Address / City / State / Zip Code of your kitchen",
    preferenceCategory: "Location",
    options:{
      
    }
  },
  step4 : {
    question: "How many square feet is your kitchen space?",
    preferenceCategory: "Location",
    options: {
      1: "200 sq. ft - 400 sq. ft",
      2: "500 sq. ft - 700 sq. ft",
      3: "800 sq. ft - 1000 sq. ft",
      4: "1001 sq. ft +"
    }
  },
  step5 : {
    question: "What type of kitchen do you have?",
    preferenceCategory: "Kitchen",
    options: {
      1: "Restaurant",
      2: "Commerical Kitchen",
      3: "Venue Kitchen",
      4: "Ghost Kitchen",
      5: "Cloud Kitchen",
      6: "Other"
    }
  },
  step6: {
    question: "Please select the equipment you have in your kitchen for chefs to use.",
    preferenceCategory: "Kitchen",
    options: {
      1: "Range",
      2: "Commercial Oven",
      3: "Fryer",
      4: "Griddle",
      5: "Food Slicer",
      6: "Prep Tables",
      7: "Convection Oven",
      8: "Deck Oven",
      9: "Mixer",
      10: "Food Dehydrator",
      11: "Rack Oven",
      12: "Commercial Grinder",
      13: "Industrial Coffee Maker",
      14: "Induction Cooktop",
      15: "Members Must Provide Own Equipment",
      16: "Steam Kettle",
      17: "Tilt Skillet",
      18: "Vertical Cutter/Mix",
      19: "Food Processor",
      20: "Food Mixer",
      21: "Charbroiler",
      22: "Ice cream maker",
      23: "Bottling Line",
      24: "Blast Freezer",
      25: "Canning line",
      26: "Water Chiller",
      27: "Proofer",
      28: "Vacuum Sealer",
      29: "Dough Sheeter",
      30: "Packaging Heat Seal",
      31: "Other",
    },
  },
  step7 : {
    question: "What hours can a chef book a kitchen?",
    preferenceCategory: "Booking",
    options: {
      1: "text",
    }
  },
  step8 : {
    question: "How soon do you want to start booking you kitchen space?",
    preferenceCategory: "Booking",
    options: {
      1: "ASAP",
      2: "In the next 2-3 weeks",
      3: "In the next month",
      4: "Looking to book my space in the future (6+ months)"
    }
  },
  step9 : {
    question: "How many chefs can you have cooking at once in your kitchen?",
    preferenceCategory: "Miscellaneous",
    options: {
      1: "Only one at a time",
      2: "2-3 chefs",
      3: "5-10 chefs",
      4: "10+ chefs"
    }
  },
  step10 : {
    question: "How frequently would you like to receive payments?",
    preferenceCategory: "Miscellaneous",
    options: {
      1: "After every booking",
      2: "At the end of each week",
      3: "Bi-Weekly",
      4: "Monthly",
      5: "Quarterly",
      6: "Other"
    }
  },
  step11 : {
    question: "How much do you minimally have to charge chefs to cook in your kitchen?",
    preferenceCategory: "Miscellaneous",
    options: {
      1: "$50-$100 per hour",
      2: "$101-$200 per hour",
      3: "$201-$500 per hour",
      4: "Other"
    }
  },
}

export const usStates = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA",
  "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR",
  "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];

export const businessStages = [
  {name: "all", description: "All"},
  {name: "plan", description: "Plan Stage"},
  {name: "launch", description: "Launch Stage"},
  {name: "growth", description: "Growth Stage"}
]

export {
  kitchenStatuses,
  membershipStatuses,
  statusColors,
  preferenceSettings,
  questionaire,
  // states
};
